import React, { useState } from "react";
import "./app.css";
import { Box, Button, TextField, Typography } from "@mui/material";
import Banner from "./img/banner.png";
import Logo from "./img/logo.png";
import MyDocument from "./Pdfview";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
const App = () => {
  const [etudiant1, setEtudiant1] = useState("");
  const [etudiant2, setEtudiant2] = useState("");
  const [etudiant3, setEtudiant3] = useState("");

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [univ, setUniv] = useState("");
  const [level, setLevel] = useState("");
  const [departement, setDepartement] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [error, setError] = useState(false);
  const [seccess, setSeccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !etudiant1 ||
      !email ||
      !phone ||
      !univ ||
      !level ||
      !departement ||
      !title ||
      !desc
    ) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
    } else {
      const form = document.getElementById("form");
      const formData = new FormData(form);
      fetch(
        "https://script.google.com/macros/s/AKfycbw2ObVwb9m_zwuipN4TS2dHXgj6v7MiUqf_WRusyasG1vcty879DrVrV9H08X5e9-Gxgw/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      setSeccess(true);
      setTimeout(() => {
        setSeccess(false);
      }, 3000);
    }
  };

  return (
    <Box>
      <Box
        padding="15px 105px"
        width="100%"
        display="flex"
        justifyContent="space-between"
        backgroundColor="#294a70"
        alignItems="center"
        boxShadow="2px 11px 20px 1px rgba(41,74,112,0.75)"
        sx={{
          "@media(max-width:700px)": {
            padding: "25px 10px",
          },
        }}
      >
        <Box
          sx={{
            "@media(max-width:950px)": {
              display: "none",
            },
          }}
        >
          <img src={Logo} alt="logo" style={{ width: "225px" }} />
        </Box>

        <Box>
          <Typography
            variant="h4"
            sx={{
              fontSize: "33px",
              textAlign: "center",
              color: "white",
              marginBottom: "15px",
              fontWeight: "bold",
              "@media(max-width:1200px)": {
                textAlign: "end",
              },
              "@media(max-width:950px)": {
                textAlign: "center",
              },
            }}
          >
            المنظمة الوطنية للطلبة الأحرار
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: "33px",
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
              letterSpacing: "2px",
              "@media(max-width:1200px)": {
                textAlign: "end",
              },
              "@media(max-width:950px)": {
                textAlign: "center",
              },
            }}
          >
            National Organization for Free Students
          </Typography>
        </Box>
      </Box>

      <Box
        margin="50px 0"
        width="100%"
        padding="15px 105px"
        sx={{
          "@media(max-width:900px)": { padding: "15px 40px" },
          "@media(max-width:900px)": { padding: "15px 10px" },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "33px",
            textAlign: "center",
            fontWeight: "bold",
            letterSpacing: "1.8px",
            "@media(max-width:900px)": { fontSize: "23px" },
          }}
        >
          National competition for Algerian university students <br /> under the
          supervision of the National Organization of Free Students
        </Typography>
      </Box>

      <Box
        marginTop={2}
        padding="3px"
        width="100%"
        height="860px"
        sx={{
          "@media(max-width:1200px)": { height: "703px" },
          "@media(max-width:800px)": { height: "475px" },
          "@media(max-width:600px)": { height: "310px" },
        }}
      >
        <img
          src={Banner}
          alt="banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      <Box
        margin="50px 0"
        width="100%"
        padding="15px 105px"
        sx={{
          "@media(max-width:900px)": { padding: "15px 40px" },
          "@media(max-width:900px)": { padding: "15px 10px" },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "33px",
            textAlign: "center",
            fontWeight: "bold",
            letterSpacing: "1.8px",
            "@media(max-width:900px)": { fontSize: "23px" },
          }}
        >
          To enter the competition, please carefully fill in the following
          information
        </Typography>
        <Typography
          variant="h1"
          sx={{
            marginTop: "10px",
            fontSize: "22px",
            color: "red",
            textAlign: "center",
            letterSpacing: "1.8px",
            "@media(max-width:900px)": { fontSize: "23px" },
          }}
        >
          Please fill in all information in Latin letters
        </Typography>
      </Box>

      <Box
        padding="25px 105px"
        sx={{ "@media(max-width:750px)": { padding: "40px 15px" } }}
      >
        <Box
          padding={3}
          border="3px solid #294a70"
          borderRadius={2}
          sx={{ "@media(max-width:750px)": { padding: "40px 15px" } }}
        >
          <form onSubmit={handleSubmit}>
            <Box
              margin="15px 0"
              width="100%"
              gap={2}
              sx={{
                "@media(max-width:1000px)": { display: "block" },
              }}
            >
              <TextField
                sx={{
                  width: "100%",
                  "@media(max-width:1000px)": { marginBottom: "15px" },
                }}
                label="Student (1) - Full Name"
                onChange={(e) => setEtudiant1(e.target.value)}
              />
            </Box>
            <Box
              margin="15px 0"
              width="100%"
              gap={2}
              sx={{
                "@media(max-width:1000px)": { display: "block" },
              }}
            >
              <TextField
                sx={{
                  width: "100%",
                  "@media(max-width:1000px)": { marginBottom: "15px" },
                }}
                label="Student (2) - Full Name"
                onChange={(e) => setEtudiant2(e.target.value)}
              />
            </Box>
            <Box
              margin="15px 0"
              width="100%"
              display={"flex"}
              justifyContent="space-between"
              gap={2}
              sx={{
                "@media(max-width:1000px)": { display: "block" },
              }}
            >
              <TextField
                sx={{
                  width: "100%",
                  "@media(max-width:1000px)": { marginBottom: "15px" },
                }}
                label="Student (3) - Full Name"
                onChange={(e) => setEtudiant3(e.target.value)}
              />
            </Box>

            <Box
              margin="20px 0"
              width="100%"
              display={"flex"}
              justifyContent="space-between"
              gap={2}
              sx={{
                "@media(max-width:1000px)": { display: "block" },
              }}
            >
              <TextField
                sx={{
                  width: "100%",
                  "@media(max-width:1000px)": { marginBottom: "15px" },
                }}
                label="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                sx={{
                  width: "100%",
                }}
                label="Phone Number"
                onChange={(e) => setPhone(e.target.value)}
              />
            </Box>
            <Box marginBottom="15px">
              <TextField
                sx={{
                  width: "100%",
                }}
                label="Your current university"
                onChange={(e) => setUniv(e.target.value)}
              />
            </Box>
            <Box marginBottom="50px">
              <TextField
                sx={{
                  width: "100%",
                }}
                label="Level"
                onChange={(e) => setLevel(e.target.value)}
              />
              <TextField
                sx={{
                  width: "100%",
                  marginTop: "15px",
                }}
                label="Departement"
                onChange={(e) => setDepartement(e.target.value)}
              />
            </Box>

            <Box>
              <TextField
                sx={{
                  width: "100%",
                }}
                label="Idea Title"
                onChange={(e) => setTitle(e.target.value)}
              />
              <textarea
                placeholder="Description of the idea"
                style={{
                  borderRadius: "4px",
                  resize: "none",
                  width: "100%",
                  height: "200px",
                  border: "1px solid #333",
                  padding: "12px",
                  marginTop: "12px",
                  fontSize: "20px",
                }}
                onChange={(e) => setDesc(e.target.value)}
              />
            </Box>
            <Box
              marginTop={2}
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  padding: "8px 50px",
                  letterSpacing: "5px !important",
                  background: "#294a70",
                  "&:hover": {
                    background: "#294a70",
                  },
                }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  padding: "8px 50px",
                  marginTop: "15px",
                  letterSpacing: "5px !important",
                  background: "#294a70",
                  "&:hover": {
                    background: "#294a70",
                  },
                }}
              >
                <PDFDownloadLink
                  style={{ textDecoration: "none", color: "white" }}
                  document={
                    <MyDocument
                      fn1={etudiant1}
                      fn2={etudiant2}
                      fn3={etudiant3}
                      univ={univ}
                      depar={departement}
                      level={level}
                      title={title}
                      desc={desc}
                      phone={phone}
                      email={email}
                    />
                  }
                  fileName={`StarTude-${new Date()
                    .getTime()
                    .toString()
                    .slice(0, 10)}`}
                >
                  {({ loading }) => (loading ? "Loading" : "Download The Form")}
                </PDFDownloadLink>
              </Button>
              {error && (
                <span
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginTop: "12px",
                    color: "red",
                    fontSize: "18px",
                  }}
                >
                  please cheak you're information ...!!
                </span>
              )}
              {seccess && (
                <span
                  style={{
                    textAlign: "center",
                    width: "100%",
                    marginTop: "12px",
                    color: "green",
                    fontSize: "18px",
                  }}
                >
                  Your registration has been successful
                </span>
              )}
            </Box>
          </form>
        </Box>
      </Box>

      <Box
        marginTop={9}
        padding="15px 105px"
        width="100%"
        display="flex"
        justifyContent="space-between"
        backgroundColor="#294a70"
        alignItems="center"
        boxShadow="2px 11px 20px 1px rgba(41,74,112,0.75)"
        sx={{
          "@media(max-width:700px)": {
            padding: "25px 10px",
          },
        }}
      >
        <Box
          sx={{
            "@media(max-width:950px)": {
              display: "none",
            },
          }}
        >
          <img src={Logo} alt="logo" style={{ width: "225px" }} />
        </Box>

        <Box>
          <Typography
            variant="h4"
            sx={{
              fontSize: "33px",
              textAlign: "center",
              color: "white",
              marginBottom: "15px",
              fontWeight: "bold",
              "@media(max-width:1200px)": {
                textAlign: "end",
              },
              "@media(max-width:950px)": {
                textAlign: "center",
              },
            }}
          >
            المنظمة الوطنية للطلبة الأحرار
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: "33px",
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
              letterSpacing: "2px",
              "@media(max-width:1200px)": {
                textAlign: "end",
              },
              "@media(max-width:950px)": {
                textAlign: "center",
              },
            }}
          >
            National Organization for Free Students{" "}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ height: "0px", width: "0px", overflow: "hidden" }}>
        <form id="form">
          <input type="text" name="etudiant1" value={etudiant1} />
          <input type="text" name="etudiant2" value={etudiant2} />
          <input type="text" name="etudiant3" value={etudiant3} />

          <input type="text" name="email" value={email} />
          <input type="text" name="phone" value={phone} />
          <input type="text" name="university" value={univ} />
          <input type="text" name="level" value={level} />
          <input type="text" name="depart" value={departement} />
          <input type="text" name="title" value={title} />
          <input type="text" name="desc" value={desc} />
        </form>
      </Box>
    </Box>
    /*
    <PDFViewer width="1800px" height="965px">
      <MyDocument
        fn1={etudiant1}
        fn2={etudiant2}
        fn3={etudiant3}
 
        univ={univ}
        depar={departement}
        level={level}
        title={title}
        desc={desc}
        phone={phone}
        email={email}
      />
    </PDFViewer>*/
  );
};

export default App;
